/**
 * Guest 세션의 북마크는 저장하지 않는다.
 *
 * 북마크는 원래 `localStorage["bookmark:<key>"]`에 남는데, 이 저장소는 계정과 무관해서
 * Guest가 누른 북마크가 로그아웃·재로그인 뒤 다시 Guest로 들어와도 그대로 남았다.
 * Guest 세션 동안에는 localStorage 대신 메모리만 쓰고, 세션이 바뀌면 비운다.
 */
let guestSession = false;
const guestBookmarks = new Set<string>();

/**
 * 현재 세션이 Guest인지 알린다.
 * 세션 종류가 바뀌면(Guest→회원, 회원→Guest) 이전 Guest 흔적을 남기지 않는다.
 */
export function setGuestBookmarkSession(isGuest: boolean): void {
  if (guestSession === isGuest) return;

  guestSession = isGuest;
  guestBookmarks.clear();
}

export function isGuestBookmarkSession(): boolean {
  return guestSession;
}

export function isGuestBookmarked(fileKey: string): boolean {
  if (!fileKey) return false;
  return guestBookmarks.has(fileKey);
}

export function addGuestBookmark(fileKey: string): void {
  if (!fileKey) return;
  guestBookmarks.add(fileKey);
}

export function removeGuestBookmark(fileKey: string): void {
  if (!fileKey) return;
  guestBookmarks.delete(fileKey);
}

export function clearGuestBookmarks(): void {
  guestBookmarks.clear();
}

/** 테스트 전용 — 모듈 전역 상태를 초기 상태로 되돌린다. */
export function resetGuestBookmarkSessionForTest(): void {
  guestSession = false;
  guestBookmarks.clear();
}
